import AboutSection from './components/aboutSection';
import CtaSection from './components/ctaSection';
import EventSection from './components/eventSection';
import HeroSection from './components/heroSection';
import RegionSection from './components/regionSection';
import MapSection from './components/mapSection';
import StepSection from './components/stepSection';
import TestimonialSection from './components/testimonialSection';
import Seo from '@/components/Seo/Seo';

interface LandingPageProps {
  onDownloadClick: () => void;
}

export default function LandingPage({
  onDownloadClick,
}: LandingPageProps): JSX.Element {
  return (
    <>
      <Seo
        title="UK Vineyard Guide – Explore English & Welsh Wine Country"
        description="Discover and plan vineyard visits across England and Wales. Interactive maps, tour info, events, tastings and expert recommendations – all in one app."
        canonicalUrl="https://www.ukvineyardguide.co.uk"
      />
      <HeroSection onDownloadClick={onDownloadClick} />
      <AboutSection />
      <StepSection onDownloadClick={onDownloadClick} />
      <MapSection onDownloadClick={onDownloadClick} />
      <EventSection onDownloadClick={onDownloadClick} />
      <RegionSection onDownloadClick={onDownloadClick} />
      <TestimonialSection />
      <CtaSection />
    </>
  );
}
